import { NextPage } from 'next'
import dynamic from 'next/dynamic'
import { getIDeviceComponent } from '@ucheba/utils/helpers/components'
import { IObjectDevicesComponents } from '@ucheba/utils/helpers/components/types'
import React from 'react'
import { NextSeo } from 'next-seo'
import { NextPageContext } from 'next/dist/shared/lib/utils'
import { Store } from 'redux'
import { professionsIdSelectors, professionsIdThunks } from '@ucheba/store/professions/id'
import Custom404 from '../../404.page'
import { IProfIdPageProps } from './types'
import { getAvailableProgramTypes } from './bll/useProfByIdCore'
import { fetchInstitutionsByProfession } from './components/WhereAreStudying/bll'
import { fetchSpecialitiesByProfession } from './components/SpecialitiesByProf/bll'

const devicesPages: IObjectDevicesComponents = {
  desktop: dynamic(() => import('./desktop/ProfIdPage')),
  touch: dynamic(() => import('./touch/ProfIdPage')),
}

const ProfIdPage: NextPage<IProfIdPageProps> = (props) => {
  const { content, canonical, notFound } = props

  if (notFound) {
    return <Custom404 />
  }

  return (
    <>
      <NextSeo
        title={content.seo.title}
        description={content.seo.description}
        canonical={canonical}
        openGraph={{
          images: [
            {
              url: '',
              width: 1200,
              height: 630,
            },
          ],
        }}
      />

      {getIDeviceComponent(props, devicesPages)}
    </>
  )
}

ProfIdPage.getInitialProps = async (
  ctx: NextPageContext & { store: Store }
): Promise<any> => {
  const { store, query, res } = ctx
  const { dispatch, getState } = store
  const { id } = query

  if (id) {
    await dispatch<any>(professionsIdThunks.fetch({ ctx, data: { id } }))
  }

  const profession = professionsIdSelectors.entity(getState())

  if (!profession) {
    if (res) {
      res.statusCode = 404
    }

    return {
      notFound: true,
    }
  }

  const availableProgramTypes = getAvailableProgramTypes(profession)

  const { tagIds, name, specialityIds } = profession || {}

  const requiredPromises = []

  requiredPromises.push(
    dispatch<any>(professionsIdThunks.fetchSimilar({ ctx, data: { id, limit: 3 } }))
  )

  if (specialityIds && specialityIds.length > 0 && availableProgramTypes.length) {
    requiredPromises.push(
      fetchSpecialitiesByProfession(availableProgramTypes[0], specialityIds, dispatch, 5)
    )
  }

  if (availableProgramTypes.length) {
    requiredPromises.push(
      fetchInstitutionsByProfession(
        availableProgramTypes[0],
        tagIds,
        specialityIds,
        dispatch
      )
    )
  }

  await Promise.all(requiredPromises)

  return {
    content: {
      seo: {
        title: `Профессия ${name} — Учёба.ру`,
        description: `Вся правда о профессии ${name}: чем занимается, как стать, где работать, сколько зарабатывает и какое образование нужно получить.`,
      },
    },
    availableProgramTypes,
  }
}

export default ProfIdPage
